import styled from '@emotion/styled';
import ArrowUp24 from '@icons/arrow/ArrowUp24';
import { pressActionEffect } from '@styles/mixin';

interface Props {
    /** 하단 버튼 영역이 있으면 그 위로 띄운다 */
    hasFooter?: boolean;
}

/** 스크롤을 맨 위로 올리는 플로팅 버튼 */
function ScrollTopButton({ hasFooter }: Props) {
    const handleClick = () => {
        document.querySelector<HTMLDivElement>('#cta-contents')
            ?.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <Base type='button'
            aria-label='scroll to top'
            data-footer={hasFooter}
            onClick={handleClick}>
            <ArrowUp24/>
        </Base>
    );
}

const Base = styled.button`
    align-items: center;
    background-color: var(--color-background-pure);
    border-radius: var(--radius-m);
    bottom: calc(var(--safe-area-bottom) + 26px);
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    height: 40px;
    justify-content: center;
    padding: var(--spacing-2);
    position: fixed;
    right: var(--spacing-4);
    width: 40px;
    z-index: 2;
    ${pressActionEffect}

    /* 하단 버튼 영역(84px) 위로 16px 띄운다 */
    &[data-footer="true"] {
        bottom: calc(var(--safe-area-bottom) + 100px);
    }
`;

export default ScrollTopButton;
